import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import * as S from "./navBar.style";
import { ReactComponent as IconHome } from "../../../styles/assets/svg/nav_home_off.svg";
import { ReactComponent as IconReport } from "../../../styles/assets/svg/nav_report_off.svg";
import { ReactComponent as IconPoint } from "../../../styles/assets/svg/nav_point_off.svg";
import { ReactComponent as IconMyInfo } from "../../../styles/assets/svg/nav_my_off.svg";
import { ReactComponent as IconCamera01 } from "../../../styles/assets/svg/icon_camera_01.svg";
import { ReactComponent as IconPill } from "../../../styles/assets/svg/icon_pill.svg";
import { ModalBottom } from "src/components/molecules/ModalBottom";
import { titleText } from "../MainHeaderBox/MainConHeader";
import { subtitleText } from "src/pages/diet/DietPage";
import dayjs from "dayjs";
import { ModalDietNote } from "src/components/molecules/ModalDietNote";

export type TabKey = "home" | "report" | "point" | "myinfo";

type Props = {
  active: TabKey | null;
  px: (n: number) => number;
  containerWidth?: number;
};

const NavBar: React.FC<Props> = ({ active, px, containerWidth }) => {
  const today = dayjs().format("YYYY.MM.DD");

  const [modalShow, setModalShow] = useState<boolean>(false);
  const [modalDietShow, setModalDietShow] = useState<boolean>(false);
  const navigate = useNavigate();
  const formattedDate = today.split(".").join("");

  // 탭 기본 라우팅
  const tabRoutes: Record<TabKey, string> = {
    home: "/",
    report: "/report",
    point: "/point",
    myinfo: "/myinfo",
  };

  // 아이콘 매핑
  const icons: Record<TabKey, any> = {
    home: <IconHome />,
    report: <IconReport />,
    point: <IconPoint />,
    myinfo: <IconMyInfo />,
  };

  // 테스트용 동일 path 설정
  const goTab = (k: TabKey) => navigate(tabRoutes[k]);

  const TabBtn = ({ k, label }: { k: TabKey; label: string }) => {
    const isActive = active === k;
    return (
      <S.TabItem type="button" onClick={() => goTab(k)} $isActive={isActive}>
        {icons[k]}
        <div>{label}</div>
      </S.TabItem>
    );
  };

  return (
    <div
      style={{
        position: "fixed",
        left: 0,
        right: 0,
        bottom: 0,
        display: "flex",
        justifyContent: "center",
        zIndex: 999,
      }}
    >
      <div style={{ position: "relative", width: "100%", maxWidth: "45rem" }}>
        {/* ✅ FAB: 항상 표시, 지금은 로그만 찍음 */}

        {/* 탭 바 */}
        <nav
          style={{
            height: px(62),
            background: "#FFFFFF",
            // borderTop: `${px(1)}px solid #E5E7EB`,
            borderRadius: `${px(30)}px ${px(30)}px 0 0`,
            display: "grid",
            gridTemplateColumns: "repeat(5, 1fr)",
            justifyItems: "center",
            alignItems: "center",
            textAlign: "center",
            padding: `0 ${px(8)}px`,
          }}
        >
          <TabBtn k="home" label="홈" />
          <TabBtn k="report" label="건강 리포트" />
          <button
            type="button"
            onClick={() => setModalShow(true)}
            aria-label="add"
            style={{
              // position: "relative",
              // top: -20,
              transform: `translate(0, -${px(17)}px)`,
              zIndex: 20,
              width: px(52),
              height: px(52),
              borderRadius: "50%",
              background: "linear-gradient(148deg, #FBD984 0%, #FFA040 100%)",
              color: "#fff",
              border: "none",
              display: "grid",
              placeItems: "center",
              boxShadow: "0px 4px 4px rgba(245, 124, 0, 0.20)",
              cursor: "pointer",
            }}
          >
            <svg width={px(32)} height={px(32)} viewBox="0 0 24 24">
              <path
                d="M12 5v14M5 12h14"
                stroke="#fff"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          </button>
          <TabBtn k="point" label="포인트" />
          <TabBtn k="myinfo" label="내정보" />
        </nav>
      </div>
      {modalShow && (
        <ModalBottom title="" onClose={() => setModalShow(false)}>
          <div
            style={{
              // padding: 16,
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "center",
              gap: 8,
              display: "flex",
            }}
          >
            <div
              style={{
                alignSelf: "stretch",
                height: 56,
                padding: 8,
                background: "var(--neutral-100, #F5F5F5)",
                borderRadius: 12,
                justifyContent: "space-between",
                alignItems: "center",
                display: "inline-flex",
              }}
              onClick={() => {
                setModalShow(false);
                setModalDietShow(true);
              }}
            >
              <div style={{ width: 24, height: 24, position: "relative" }}>
                <IconCamera01 />
              </div>
              <div
                style={{
                  flex: "1 1 0",
                  textAlign: "center",
                  justifyContent: "center",
                  display: "flex",
                  flexDirection: "column",
                  color: "var(--neutral-800, #262626)",
                  fontSize: 16,
                  fontWeight: "500",
                  lineHeight: "20px",
                }}
              >
                식단 기록
              </div>
            </div>
            <div
              style={{
                alignSelf: "stretch",
                height: 56,
                padding: 8,
                background: "var(--neutral-100, #F5F5F5)",
                borderRadius: 12,
                justifyContent: "space-between",
                alignItems: "center",
                display: "flex",
              }}
              onClick={() => navigate("/pill/write")}
            >
              <div
                style={{
                  width: 24,
                  height: 24,
                  position: "relative",
                  overflow: "hidden",
                }}
              >
                <IconPill />
              </div>
              <div
                style={{
                  flex: "1 1 0",
                  textAlign: "center",
                  justifyContent: "center",
                  display: "flex",
                  flexDirection: "column",
                  color: "var(--neutral-800, #262626)",
                  fontSize: 16,
                  fontWeight: "500",
                  lineHeight: "20px",
                }}
              >
                복약 기록
              </div>
            </div>
          </div>
        </ModalBottom>
      )}
      {modalDietShow && (
        <ModalDietNote
          setOpen={setModalDietShow}
          titleText={titleText}
          subtitleText={subtitleText}
          formattedDate={formattedDate}
        />
      )}
    </div>
  );
};

export default NavBar;
